import React from "react";
import {
  Paper,
  Stack,
  Typography,
  Zoom,
  useTheme,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import EventBusyIcon from "@mui/icons-material/EventBusy";

import { getHomeRegistrationHeroPaperSx } from "./homeConstants";
import { useAppSelector } from "../../store";
import { getTournoi } from "../../features/tournoi/tournoiSlice";
import { resolveTournoiHome } from "../../utils/resolveTournoiHome";

export type HomeCancelledHeroProps = {
  tournamentLabel: string;
};

/**
 * Hero minimal pour l'état « tournoi annulé » : statut + dates uniquement.
 */
export const HomeCancelledHero: React.FC<HomeCancelledHeroProps> = ({
  tournamentLabel,
}) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const tournoi = useAppSelector(getTournoi);
  const home = resolveTournoiHome(tournoi);

  return (
    <Zoom in>
      <Paper
        elevation={0}
        sx={{
          ...getHomeRegistrationHeroPaperSx(theme),
          mb: { xs: 2.5, sm: 3 },
          p: { xs: 2.25, sm: 3, md: 3.25 },
          border: `1px solid ${alpha(theme.palette.error.main, isDark ? 0.45 : 0.3)}`,
          borderLeft: `6px solid ${theme.palette.error.main}`,
        }}
      >
        <Stack spacing={1.5} sx={{ textAlign: "center", px: { xs: 0.5, sm: 1 } }}>
          <Typography
            variant="overline"
            sx={{
              display: "block",
              fontWeight: 700,
              letterSpacing: "0.16em",
              color: isDark ? "grey.200" : "primary.dark",
            }}
          >
            {tournamentLabel}
          </Typography>

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
          >
            <EventBusyIcon
              sx={{
                fontSize: 30,
                color: isDark ? "error.light" : "error.main",
              }}
            />
            <Typography
              variant="h5"
              component="h1"
              sx={{
                fontWeight: 900,
                letterSpacing: "-0.02em",
                color: isDark ? "error.light" : "error.dark",
                fontSize: { xs: "1.35rem", sm: "1.5rem" },
              }}
            >
              Tournoi annulé
            </Typography>
          </Stack>

          <Typography
            variant="h6"
            component="p"
            sx={{
              m: 0,
              fontWeight: 700,
              color: isDark ? "grey.100" : "text.primary",
              fontSize: { xs: "1.05rem", sm: "1.2rem" },
              lineHeight: 1.4,
            }}
          >
            Édition initialement prévue les {home.weekendLine}
          </Typography>
        </Stack>
      </Paper>
    </Zoom>
  );
};
